export function sortAscBy<T extends Record<string, any>>(
  arr: Array<T>,
  key: keyof T
): Array<T> {
  return arr.sort(function (a, b) {
    return a[key] - b[key];
  });
}
